module.exports = __webpack_public_path__ + "img/ArrowLeft-icon.3c3ba65e.svg";